module.exports = __webpack_public_path__ + "img/promote.0f6abb44.svg";